module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "spinner spinner--rotate-square4",
    style: (_vm.styles)
  }, [_c('span', {
    staticClass: "loader-inner"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bda34966"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-loading-spinner/src/components/RotateSquare4.vue
// module id = 954
// module chunks = 170